// Tessere federali (09/10/2026): ASI A = tornei amatoriali, ASI B = corsisti (copre anche la A).
export const FEDERAZIONI = ['ASI_A', 'ASI_B', 'FIPAV'];
export const ETICHETTA = { ASI_A: 'ASI A', ASI_B: 'ASI B', FIPAV: 'FIPAV' };
export const COLORI = { ASI_A: '#0EA5E9', ASI_B: '#3B82F6', FIPAV: '#F4600C' };
export const etichetta = (fed) => ETICHETTA[fed] || fed;

// Scadenza da mostrare (12/10/2026): data salvata, altrimenti vale tutta la stagione (fino al 31/8).
// Rossa se scaduta, arancione se scade entro 30 giorni.
const oggiISO = () => new Intl.DateTimeFormat('en-CA', { timeZone: 'Europe/Rome' }).format(new Date());
export const fineValidita = (t) => {
  if (t?.data_scadenza) return String(t.data_scadenza).slice(0, 10);
  const m = /^(\d{4})/.exec(t?.stagione || '');
  return m ? `${+m[1] + 1}-08-31` : null;
};
export const giorniAllaScadenza = (t) => {
  const f = fineValidita(t);
  return f ? Math.round((new Date(f + 'T00:00:00Z') - new Date(oggiISO() + 'T00:00:00Z')) / 86400000) : null;
};
export const scadenzaInfo = (t) => {
  const f = fineValidita(t);
  if (!f) return null;
  const [a, m, g] = f.split('-');
  const gg = giorniAllaScadenza(t);
  const testo = `${t.data_scadenza ? 'scad.' : 'fino al'} ${g}/${m}/${a}`;
  return { testo, scaduta: gg < 0, colore: gg < 0 ? '#B42318' : gg <= 30 ? '#B45309' : 'var(--text-dim)', titolo: gg < 0 ? 'Scaduta' : gg <= 30 ? `Scade tra ${gg} giorni` : t.data_scadenza ? 'Scadenza indicata' : 'Nessuna scadenza indicata: vale tutta la stagione' };
};
